const billetPaymentMethod = {
  INTEGRATION: 'INTEGRATION',
  CNAB240: 'CNAB240'
};

module.exports = billetPaymentMethod;
